import { useQuery } from "@tanstack/react-query";
import { getWaffleFlags } from "../../http/endpoints";

const WAFFLE_FLAG_KEY = "featureFlags";

const useWaffleFlag = (featureFlag: string) => {
  const { data, isLoading } = useQuery({
    queryKey: [WAFFLE_FLAG_KEY, featureFlag],
    queryFn: () => getWaffleFlags({ flags: [featureFlag] }),
  });

  return { isLoading, isEnabled: data?.[0]?.active };
};

export default useWaffleFlag;
